import { useEffect } from 'react';

const Logout = () => {
  useEffect(() => {
    localStorage.removeItem('Umbre');
    window.location.href = '/login';
  }, []);

  return null;
};

export default Logout;
